import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import PopUpPublicIncident from "./popUpPublicIncident";
import MessagePopUp from '../common/messagePopUp';
import { GetIncidentUserService } from "../../Services/incidentService";
import { useTranslation } from "react-i18next";
import CheckBox from "../common/customCheckBox";

const PublicIncidentCard = ({ htmlContent, idCompany, enabled, environmentEnabled }) => {


  const [t] = useTranslation("publicIncident")
  const [showModal, setShowModal] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [privacyAgreementError, setPrivacyAgreementError] = useState(false);
  const [enableButtons, setEnableButtons] = useState(false);
  // const {id} = useLocation;
  const { id } = useParams();
  const navigate = useNavigate();

  const handleCreateIncidentClick = () => {
    navigate(`/create-incident/${idCompany}`); // Navega a la página /createIncident
  };

  const handleCreateFeedBackClick = () => {
    navigate(`/create-feedback/${idCompany}`); // Navega a la página /createIncident
  };

  const handleConsultIncidentClick = () => {
    setShowModal(true);
    setLoading(false)
  };
  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleConsultClick = async (e, inputValue) => {
    setLoading(true)
    e.preventDefault();
    const dataIncident = await GetIncidentUserService(inputValue.trim(), id);
    const data = dataIncident[0];
    if (data) {
      setLoading(false)
      navigate(`/check-incident/${data.incident}`, { state: { data } })
    } else {
      setShowPopup(true);
    }

  }

  const handleButtonMessageErrorLoginClick = () => {
    setShowPopup(false);
    setShowModal(false);
  };

  const handlePrivacyAgreementClick = (e) => {
    setEnableButtons(e);
    setPrivacyAgreementError(!e)
  };


  return (
    <div className="mt-5 public-card-container">
      <MessagePopUp
        show={showPopup}
        handleClose={() => setShowPopup(false)}
        title={t("messagesPopUp.title")}
        textBody={t("messagesPopUp.text")}
        buttonText={t("messagesPopUp.button")}
        onClickButton={handleButtonMessageErrorLoginClick}
      />
      <Card className="public-card-card custom-shadow">
        <Card.Body className="public-card-body">
          {/* Mostrar el contenido HTML */}
          <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
        </Card.Body>
        <Card.Footer className="public-card-footer d-flex align-items-center flex-column">
          <div className="d-flex text-nowrap">
            <p className="w-100">
              <CheckBox
                text={t("startCard.privacyAgreementText")}
                error={privacyAgreementError}
                onChange={(e) => handlePrivacyAgreementClick(e)}
                bigCheck
                isHtml
              />
            </p>
          </div>
          <div className="w-100 d-flex justify-content-around ">
            {enabled && environmentEnabled ?
              <>
                <Button
                  variant="primary"
                  className="custom-button-tertiary"
                  onClick={handleCreateFeedBackClick}>
                  {t("startCard.createFeedback")}
                </Button>
                <Button
                  variant="primary"
                  className="custom-button-primary"
                  onClick={() => {
                    if (!enableButtons) {
                      setPrivacyAgreementError(true)
                    } else {
                      handleCreateIncidentClick();
                    }
                  }}
                  style={{
                    cursor: !enableButtons && "not-allowed",
                    opacity: enableButtons ? 1 : 0.6,
                  }}
                >
                  {t("startCard.createButton")}
                </Button>
              </>
              : null
            }
            <Button
              variant="secondary"
              className="custom-button-secondary"
              onClick={() => {
                if (!enableButtons) {
                  setPrivacyAgreementError(true)
                } else {
                  handleConsultIncidentClick();
                }
              }}
              style={{
                cursor: !enableButtons && "not-allowed",
                opacity: enableButtons ? 1 : 0.6,
              }}
            >
              {t("startCard.checkButton")}
            </Button>
          </div>


        </Card.Footer>
      </Card>
      <PopUpPublicIncident
        show={showModal}
        handleClose={handleModalClose}
        title={t("checkPopUp.title")}
        buttonText={t("checkPopUp.button")}
        label={t("checkPopUp.label")}
        validationType={"only_input"}
        onSubmit={handleConsultClick}
        loading={loading}
        loadingText={t("checkPopUp.loadingText")}
      />
    </div>
  );
};

export default PublicIncidentCard;
